// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"MobileSwitcher_mobileNav__2DMFz","open":"MobileSwitcher_open__KhU5t"};